export const ENGLISH_NAV = [
    {
        id: "dashboard",
        label: "Dashboard",
        path: "/",
    },
    {
        id: "inventory",
        label: "Inventory",
        path: "/inventory",
    },
    {
        id: "enhancedVisibility",
        label: "Enhanced Visibility",
        path: "/enhanced",
    },
    {
        id: "emailNotifications",
        label: "Email Notifications",
        path: "/email-notifications",
    },
    {
        id: "planning",
        label: "Planning",
        path: "/calendar-view",
        sub: [
            {
                id: "forecasting",
                label: "Forecasting",
                path: "/calendar-view",
            },
            {
                id: "carOrders",
                label: "Car Orders",
                path: "/car-order",
            },
            {
                id: "generalPlacement",
                label: "General Placement",
                path: "/general-placement",
            },
            {
                id: "switchRequests",
                label: "Switch Requests",
                path: "/switch-requests",
            },
        ],
    },
    {
        id: "shipping",
        label: "Shipping",
        path: "/shipping",
        sub: [
            {
                id: "ebol",
                label: "eBOL",
                path: "/ebol",
            },
        ],
    },
    {
        id: "chargeManagement",
        label: "Charge Management",
        path: "/chargeManagement",
    },
]
